<template>
  <div class="newPlay">
    <div v-html="newsData.content"></div>
  </div>
</template>

<script>
import { getResourceNewsDetail } from "@/utils/request.js";

export default {
  props: ["id"],
  created() {
    getResourceNewsDetail(this.id).then((res) => {
      if (res.code == 0) {
        this.newsData = res.data;
      }
    });
  },
  data() {
    return {
      newsData: {},
    };
  },
};
</script>

<style lang="less" scoped>
.newPlay {
  width: 100%;
  overflow: auto;
  max-height: 379px;
  background: #fff;
  margin: auto;
}
</style>
